//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  workStatusList,
  employeeWorkStatus,
  updateEmpWorkstatus,
  delHistoryWorkstatus
} from '@/api/systemManagement/workStatus'
export default {
  name: 'workStatus',
  components: {

  },
  data () {
    var isCustomizedStatus = (rule, value, callback) => {
      if ((value === 0) && (!this.customzedworkstatus)) {
        callback(new Error('请输入自定义状态'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      statusList: [],
      selectWorkStatus: {
        wid: ''
      },
      customzedworkstatus: '',
      rules: {
        wid: [
          { required: true, message: '请选择工作状态', trigger: 'change' },
          { validator: isCustomizedStatus, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open (status) {
      this.getList()
      if (status) {
        this.selectWorkStatus.wid = status.wid
        if (status.wid === 0) {
          this.customzedworkstatus = status.workstatus
        }
      }
      this.dialogVisible = true
    },
    getList () {
      workStatusList().then(res => {
        if (res.data.code === '200') {
          this.statusList = res.data.data
        }
      })
    },
    editWorkstatus () {
      this.$refs.form.validate(isValid => {
        if (isValid) {
          let postData = {}
          if (this.selectWorkStatus.wid == 0) {
            postData.workstatus = this.customzedworkstatus
          } else {
            postData = this.selectWorkStatus
          }
          updateEmpWorkstatus(postData).then(res => {
            if (res.data.code === '200') {
              this.$emit('editSuccess')
              this.dialogVisible = false
              this.$message({
                type: 'success',
                message: '修改成功'
              })
            }
          })
        }
      })
    },
    handleClose () {
      this.selectWorkStatus.wid = ''
      this.customzedworkstatus = ''
    },
    selectRadio () {
      this.$refs.customzedworkstatusWrap.$el.click()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/layout/components/WorkStatus.vue